import React from "react";
class FaqContent extends React.Component {
  render() {
    return (
        <section className="section " style={{ paddingTop: "40px" }}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="text-left">
                  <h3
                      className="font-weight-bold"
                      style={{ color: "#0076be", fontSize: "1.3rem" }}
                  >
                    GENERAL
                  </h3>

                  <div className="tab blue">
                    <input id="tab-1" type="radio" name="tabs2" checked />
                    <label for="tab-1">What is the MightyWifi Hotspot?</label>
                    <div className="tab-content">
                      <p>
                        Also known as a pocket Wi-Fi, MiFi, global/mobile hotspot,
                        the MightyWifi Hotspot works similarly to your wireless
                        router at home. It creates a wireless hotspot that anyone
                        in the vicinity can connect to, given the password.
                        However, unlike your router at home, the MightyWifi is
                        portable and works in over 100 countries. Simply turn on
                        and connect! This means that you can travel the world with
                        your smartphone, laptop, tablet, game console, and your
                        favorite devices, knowing that you will always have a
                        secure and reliable internet connection.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-2" type="radio" name="tabs2" />
                    <label for="tab-2">
                      How does the MightyWifi actually connect worldwide?
                    </label>
                    <div className="tab-content">
                      <p>
                        The MightyWifi uses a patented virtual SIM technology that
                        allows seamless connectivity all over the world. When you
                        power the MightyWifi on, it will automatically figure out
                        which country it's in and choose the best network operator
                        for you.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-3" type="radio" name="tabs2" />
                    <label for="tab-3">
                      What devices can connect to the MightyWifi?
                    </label>
                    <div className="tab-content">
                      <p>
                        The MightyWifi works with any WiFi-enabled device, such as
                        laptops (e.g. Windows & Mac), smartphones (e.g. iPhone,
                        Android, Blackberry, Windows Phone) tablets (e.g. iPad,
                        Samsung Galaxy, Kindle) and anything else that can connect
                        to WiFi (e.g. game consoles).{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-4" type="radio" name="tabs2" />
                    <label for="tab-4">How do I use the MightyWifi?</label>
                    <div className="tab-content">
                      <p>
                        To connect to the MightyWifi, first power it on, and then
                        locate the device's unique network name (SSID) and
                        password. Select the SSID on your smartphone or other
                        device, and enter the password. That's it. You are now
                        connected!{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-5" type="radio" name="tabs2" />
                    <label for="tab-5">
                      Does the MightyWifi work with carrier-locked devices?
                    </label>
                    <div className="tab-content">
                      <p>
                        Yes, because the MightyWifi emits a WiFi signal, it works
                        even with carrier-locked devices!{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-6" type="radio" name="tabs2" />
                    <label for="tab-6">
                      How many devices can I connect to the MightyWifi?
                    </label>
                    <div className="tab-content">
                      <p>
                        You can connect up to ten different devices to the
                        MightyWifi. Please note that the connection speed will be
                        shared among each device connected, so having ten devices
                        connected at the same time could result in a noticeable
                        speed slowdown.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-7" type="radio" name="tabs2" />
                    <label for="tab-7">How long does the battery last?</label>
                    <div className="tab-content">
                      <p>
                        A MightyWifi with a fully charged battery will last around
                        12 hours while connected to one device. The MightyWifi can
                        be charged via USB or a wall outlet (both cables
                        included). There is also the option of getting a power
                        bank to extend the duration.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-8" type="radio" name="tabs2" />
                    <label for="tab-8">What is the download/upload speed?</label>
                    <div className="tab-content">
                      <p>
                        The speed of the MightyWifi's connection depends on
                        coverage. The stronger the coverage, the faster and more
                        reliable the speed. Under normal conditions, the speed
                        should be fast enough for normal internet activities, such
                        as browsing the web and sending emails. However, if the
                        area you're in has poor coverage or is experiencing
                        adverse weather, you will get suboptimal speeds.
                        <br />
                        <b>4G</b>
                        <br />
                        Theoretic data speeds: 100 Mbps when moving, e.g. in a
                        car; 1 Gbps when standing still. Real-world data speeds:
                        18.6 Mbps and upload speeds of 9.0 Mbps
                        <br />
                        <b>3G</b>
                        <br />
                        Theoretic data speeds: 7.2 Mbps or 52 Mbps on 3G HSPA+
                        Real-world data speeds: 4.3 Mbps download and 1.1 Mbps
                        upload
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-9" type="radio" name="tabs2" />
                    <label for="tab-9">
                      Can I make calls or send texts with the MightyWifi?
                    </label>
                    <div className="tab-content">
                      <p>
                        The MightyWifi only gives you an internet connection. It
                        does not enable voice calls or text/multi-media messages
                        via your cellular network. However, it works VoIP, such as
                        Skype, Viber, and Google Voice and works with messaging
                        apps, such as WhatsApp.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-10" type="radio" name="tabs2" />
                    <label for="tab-10">Why should I rent the MightyWifi?</label>
                    <div className="tab-content">
                      <p>
                        The MightyWifi provides the best data plans for
                        international internet services. We are a US based company
                        and operate in-house customer services.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-11" type="radio" name="tabs2" />
                    <label for="tab-11">
                      Can I buy a MightyWifi instead of renting?
                    </label>
                    <div className="tab-content">
                      <p>Absolutely! Please check out our purchasing options. </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-12" type="radio" name="tabs2" />
                    <label for="tab-12">
                      Should I rent or buy the MightyWifi?
                    </label>
                    <div className="tab-content">
                      <p>
                        If you travel only a couple of times a year, then renting
                        the MightyWifi is probably best for you. Renting is also
                        advisable for first-time users, so that you can see what
                        it's all about.{" "}
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-13" type="radio" name="tabs2"/>
                    <label for="tab-13">
                      What do I do when my MightyWifi Device is overheating?
                    </label>
                    <div className="tab-content">
                      <p>
                        Plug out the MightyWifi Device from the charger. Most cases of overheating are caused by overcharging. Overheating the battery may cause damage to the battery and shorten the lifespan of the battery. Wait for the MightyWifi Device to cool off before you continue charging. When the battery is fully charged, please remove the charger.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-14" type="radio" name="tabs2"/>
                    <label for="tab-14">
                      What do I do when the time and the date is off?
                    </label>
                    <div className="tab-content">
                      <p>
                        The time and date show the last time the MightyWifi Device was connected to our cloud servers. This is the reason why the time and date are inaccurate. The time and the date will update accordingly when the MightyWifi device is connected to our cloud servers.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-15" type="radio" name="tabs2"/>
                    <label for="tab-15">
                      My device is stuck on “Please wait…” or “Powering off” what do I do?
                    </label>
                    <div className="tab-content">
                      <p>
                        If the device is stuck on either screen after a couple of minutes do the following: Find the small circular hole which is close to the charging port for the MightyWifi device. Gently insert a paperclip in that hole for about 10 seconds. If done successfully, the device will turn off by itself.
                        Note: Do not forcefully press or jam the paperclip in the hole. This can cause damage to the device reset function. Simply push slowly until you hear a “click” noise and hold the paperclip in that position until the device turns off.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-16" type="radio" name="tabs2"/>
                    <label for="tab-16">
                      My device shows this message at the top, “No valid orders in the current region” what do I do?
                    </label>
                    <div className="tab-content">
                      <p>
                        This message indicates that the MightyWifi device is currently out of data. Purchase more data either on our website (Mightywifi.net) or our app (MightyWifi Cloud). After you purchase data, please restart the device.
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    COUNTRIES COVERED
                  </h3>

                  <div className="tab blue">
                    <input id="tab-101" type="radio" name="tabs2" />
                    <label for="tab-101">
                      Which countries does the MightyWifi work in?
                    </label>
                    <div className="tab-content">
                      <p>
                        <b>Africa</b>
                        <br />
                        Egypt, South Africa, Morocco
                        <br />
                        <br />
                        <b>Asia</b>
                        <br />
                        Cambodia (excluding Angkor Wat), China, Hong Kong,
                        Indonesia, Israel, Japan, Macao, Malaysia, Philippines
                        (excluding Boracay), Singapore, South Korea, Sri Lanka,
                        Taiwan, Thailand, United Arab Emirates, Myanmar, Vietnam
                        <br />
                        <br />
                        <b>Europe</b>
                        <br />
                        Albania, Austria, Belgium, Bosnia and Herzegovina,
                        Bulgaria, Croatia, Cyprus, Czech Republic, Denmark,
                        Estonia, Finland, France, Germany, Gibraltar, Greece,
                        Hungary, Iceland, Ireland, Italy, Latvia, Liechtenstein,
                        Lithuania, Luxembourg, Malta, Monaco, Netherlands, Norway,
                        Poland, Portugal, Romania, Russia, San Marino, Slovakia,
                        Slovenia, Spain, Sweden, Switzerland, Turkey, United
                        Kingdom, Vatican
                        <br />
                        <br />
                        <b>Americas</b>
                        <br />
                        Canada, United States of America
                        <br />
                        <br />
                        <b>Oceania</b>
                        <br />
                        Australia, New Zealand
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-102" type="radio" name="tabs2" />
                    <label for="tab-102">
                      Can I use the MightyWifi outside of its geographical scope
                      of operation?
                    </label>
                    <div className="tab-content">
                      <p>
                        The MightyWifi is not meant to be used outside its
                        intended locations. Please contact us beforehand if you
                        wish to do so.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-103" type="radio" name="tabs2" />
                    <label for="tab-103">
                      What happens to my connection as I travel from country to
                      country?
                    </label>
                    <div className="tab-content">
                      <p>
                        You may briefly lose connectivity when crossing a national
                        border as you connect to a new network.
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    NETWORK COVERAGE
                  </h3>

                  <div className="tab blue">
                    <input id="tab-104" type="radio" name="tabs2" />
                    <label for="tab-104">What is the coverage like?</label>
                    <div className="tab-content">
                      <p>
                        MightyWifi partners with the biggest network operators
                        worldwide to ensure that you always have the best and
                        fastest connections available to you. There will always be
                        great coverage in populated areas, but if you are
                        traveling to rural or uninhabited areas, such as the Alps,
                        contact us in advance to verify the coverage.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-105" type="radio" name="tabs2" />
                    <label for="tab-105">
                      Is there coverage out at sea (maritime coverage)?
                    </label>
                    <div className="tab-content">
                      <p>
                        The device will not work while you are out in open waters
                        but will be able to pick up a signal when you are close to
                        land. Please note that if your cruise advertises mobile
                        connectivity on board, it is most likely satellite-based
                        and will not work with the MightyWifi.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-106" type="radio" name="tabs2" />
                    <label for="tab-106">
                      If my cell phone can receive a signal, will the MightyWifi
                      as well?
                    </label>
                    <div className="tab-content">
                      <p>
                        Not necessarily. Cell phones work off of different
                        networks from the MightyWifi. The MightyWifi connects to
                        data networks (2G, 3G, LTE, 4G), whereas cell phones
                        connect to cellular networks. There is greater
                        infrastructure for cellular networks than for data
                        networks, because cellular networks have been around
                        longer, especially in rural areas. For this reason, you
                        might be able to make calls in rural areas but not access
                        the internet.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-107" type="radio" name="tabs2" />
                    <label for="tab-107">
                      What if there is no coverage at my location?
                    </label>
                    <div className="tab-content">
                      <p>
                        In the rare event that there is no coverage at your
                        location and you can't find coverage at other locations,
                        you may cancel your rental with no additional fees.
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    DELIVERY / PICKUP
                  </h3>

                  <div className="tab blue">
                    <input id="tab-201" type="radio" name="tabs2" />
                    <label for="tab-201">How far in advance should I book?</label>
                    <div className="tab-content">
                      <p>
                        To ensure a timely delivery, place your order at least 10
                        days prior to your travel departure date.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-202" type="radio" name="tabs2" />
                    <label for="tab-202">
                      What shipping options are available?
                    </label>
                    <div className="tab-content">
                      <p>
                        MightyWifi uses USPS priority mail services with tracking
                        numbers. We offer 2-day delivery with extra charges
                        depending on your location. A flat fee of $8 US dollars
                        will be charged for shipping each way, for a total of $16
                        on rentals. You will be charged for any duty or customs
                        fees for deliveries outside of the US.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-203" type="radio" name="tabs2" />
                    <label for="tab-203">
                      Upon placing an order, when will the MightyWifi arrive?
                    </label>
                    <div className="tab-content">
                      <p>
                        The MightyWifi is guaranteed to be delivered 1 business
                        day before the starting date of your rental.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-204" type="radio" name="tabs2" />
                    <label for="tab-204">Can I place a last-minute order?</label>
                    <div className="tab-content">
                      <p>
                        Please contact us for next-day delivery. It may not be
                        available depending on the time of your call or the region
                        you are in.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-205" type="radio" name="tabs2" />
                    <label for="tab-205">
                      What if I give the wrong shipping address?
                    </label>
                    <div className="tab-content">
                      <p>
                        The delivery service will contact you upon the first
                        delivery attempt. You will be responsible for any
                        redelivery costs.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-206" type="radio" name="tabs2" />
                    <label for="tab-206">
                      How can I request a special delivery?
                    </label>
                    <div className="tab-content">
                      <p>
                        If you would like to request shipment to a country not
                        offered on our website, or have specific delivery
                        requests, please contact us so we can make the necessary
                        arrangements.
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    RETURN
                  </h3>

                  <div className="tab blue">
                    <input id="tab-301" type="radio" name="tabs2" />
                    <label for="tab-301">
                      How do I return the MightyWifi at the end of the rental
                      period?
                    </label>
                    <div className="tab-content">
                      <p>
                        Use the pre-labeled, pre-paid envelope to return the
                        MightyWifi. Late fees will be incurred if you do not
                        return it within 2 days of the end date.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-302" type="radio" name="tabs2" />
                    <label for="tab-302">
                      If organizing my own return, where should I send the device?
                    </label>
                    <div className="tab-content">
                      <p>
                        <b>US Office:</b>
                        <br />
                        <br />
                        <b>MightyWifi</b>
                        <br />
                        560 Sylvan Ave. Unit #3180
                        <br />
                        Englewood Cliffs, NJ 07632
                        <br />
                        United States
                        <br />
                        +1 201 731 3839
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-303" type="radio" name="tabs2" />
                    <label for="tab-303">
                      What if the device gets lost on the way back?
                    </label>
                    <div className="tab-content">
                      <p>
                        You are responsible for the safe and timely return of the
                        MightyWifi. We recommend using the pre-labeled, pre-paid
                        return envelope that was provided.{" "}
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    MANAGING YOUR ORDER
                  </h3>

                  <div className="tab blue">
                    <input id="tab-401" type="radio" name="tabs2" />
                    <label for="tab-401">
                      Can I change or extend the rental dates after placing an
                      order?
                    </label>
                    <div className="tab-content">
                      <p>
                        Yes. Contact us ahead of time, and we will make the
                        necessary arrangements.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-402" type="radio" name="tabs2" />
                    <label for="tab-402">
                      What can I expect after placing an order?
                    </label>
                    <div className="tab-content">
                      <p>
                        Once your order is confirmed, you will receive an email
                        with your rental information.{" "}
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-403" type="radio" name="tabs2" />
                    <label for="tab-403">Can I cancel my rental?</label>
                    <div className="tab-content">
                      <p>
                        Yes, you may cancel your rental at any time with no
                        cancellation fees. If your device has already been
                        dispatched, we will not be able to refund the shipping
                        charges. We also cannot refund unused days on the device.
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    BILLING
                  </h3>

                  <div className="tab blue">
                    <input id="tab-501" type="radio" name="tabs2" />
                    <label for="tab-501">What currency do you charge in?</label>
                    <div className="tab-content">
                      <p>You will be charged in US Dollars.</p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-502" type="radio" name="tabs2" />
                    <label for="tab-502">
                      What forms of payments do you accept?
                    </label>
                    <div className="tab-content">
                      <p>
                        We accept debit/credit card payments through Visa,
                        Mastercard, and American Express and also payments via
                        PayPal.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-503" type="radio" name="tabs2" />
                    <label for="tab-503">When will I be billed?</label>
                    <div className="tab-content">
                      <p>
                        You will be billed immediately upon placing your order.
                        The charge will show up in your bank account from "LTI
                        Telecom LLC".
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-504" type="radio" name="tabs2" />
                    <label for="tab-504">Do you take a deposit?</label>
                    <div className="tab-content">
                      <p>
                        MightyWifi will hold a $100 US dollar deposit for rentals.
                        The deposit will be released once the device is returned.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-505" type="radio" name="tabs2" />
                    <label for="tab-505">Do prices include VAT?</label>
                    <div className="tab-content">
                      <p>
                        Yes, all prices indicated on the website include VAT.
                        Contact mighty@mightywifi.net to request a VAT invoice.
                      </p>
                    </div>
                  </div>

                  <h3
                      className="font-weight-bold"
                      style={{
                        color: "#0076be",
                        marginTop: "40px",
                        fontSize: "1.3rem"
                      }}
                  >
                    DATA USAGE
                  </h3>

                  <div className="tab blue">
                    <input id="tab-601" type="radio" name="tabs2" />
                    <label for="tab-601">How do I check my data usage?</label>
                    <div className="tab-content">
                      <p>
                        You can check data usage through the MightyWifi App.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-602" type="radio" name="tabs2" />
                    <label for="tab-602">
                      How much data does browsing websites use?
                    </label>
                    <div className="tab-content">
                      <p>
                        A standard web page is likely to download between
                        200-500KB of data. However, websites with a lot of media
                        content (pictures or videos) such as Facebook may use
                        substantially more data.
                      </p>
                    </div>
                  </div>
                  <div className="tab blue">
                    <input id="tab-603" type="radio" name="tabs2" />
                    <label for="tab-603">How much data do emails use?</label>
                    <div className="tab-content">
                      <p>
                        A general rule of thumb is that 50MB is enough for 250
                        emails, not accounting for any attachments. A simple text
                        email uses a few bytes at most.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-604" type="radio" name="tabs2" />
                    <label for="tab-604">How much data does Skype use?</label>
                    <div className="tab-content">
                      <p>
                        A voice call via Skype will use around 4KB/second, while a
                        video call will use 650KB/minute. These rates vary
                        according to coverage, as Skype will automatically
                        increase or decrease call and video quality according to
                        your internet speed. For reference, a 15 minute audio call
                        could use around 5MB, while a 15 minute video call could
                        use around 10MB.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-605" type="radio" name="tabs2" />
                    <label for="tab-605">
                      How much data does online gaming use?
                    </label>
                    <div className="tab-content">
                      <p>
                        Online games on a PC will use around 80MB/hour, capping at
                        100MB/hour regardless of the game. However, mobile data
                        connectivity can be a lot slower than a home network, and
                        players may find that a 3G connection is insufficient for
                        stable gameplay. For the best experience, opt for the 4G
                        upgrade.
                      </p>
                    </div>
                  </div>

                  <div className="tab blue">
                    <input id="tab-606" type="radio" name="tabs2" />
                    <label for="tab-606">
                      How can I moderate data consumption?
                    </label>
                    <div className="tab-content">
                      <p>
                        The most common way that lot of data is quickly consumed
                        is downloading/streaming audio or videos, which can exceed
                        data usage of over 100MB in 15 minutes. For reference, a
                        standard-definition movie is around 700MB.
                        <br />
                        Certain programs consume data in the background without
                        any indication. Be wary of:
                        <br />
                        <br />- Backup software, such as iCloud, Dropbox, and
                        GoogleDrive
                        <br />- Chat clients such as Skype
                        <br />- Email clients constantly downloading incoming
                        emails and attachments
                        <br />- System updates that are downloaded and installed
                        automatically without prompt
                        <br />
                        We recommend you share the above information with anyone
                        who will be using the MightyWifi with you!
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
    );
  }
}

export default FaqContent;



// WEBPACK FOOTER //
// ./src/pages/faq/FaqContent.js